const ClipperLib = window['ClipperLib'];
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { ElementGeometry } from "./ElementGeometry";
import { RoomElement } from './../RoomElement';
import { Util } from "../../utils/Util";
import { LengthProperty, NumberProperty, StringProperty, PropertyValue, Color3Property, BoolProperty, PropertyChangedResult } from "@egr/wcf/modules/core/prop";
import { degToRad } from "@egr/wcf/modules/utils/math";
export class Arena extends ElementGeometry {
    constructor(pRoomManager, pElement) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
        this.mElementParams = {};
        this.mElementParams.privacyFilter = false;
        this.mElementParams.blindVisible = false;
        this.mElementParams.blindDepth = 0.07;
        this.mElementParams.blindOpeningAngle = 60;
        this.mElementParams.blindOpeningWidth = 0;
        this.mElementParams.ColumnCount = 2;
        this.mElementParams.arenaCircle = false;
        this.mMatOfCatList_Area_TrackLane = new Array();
        this.mMatOfCatList_Area_PlayField = new Array();
        this.mMatOfCatList_Area_SideSegments = new Array();
        this.mMatOfCatList_Area_TrackLine = new Array();
        this.mTrackCAGData = [];
        this.mRoomElement.Params.arenaSegRadius = 36.5;
        this.mRoomElement.Params.arenaFieldLength = 84.4;
    }
    getType() {
        return ("Arena");
    }
    setMesh(pMesh) {
        //
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 0.5;
        tParams.depth = 0.5;
        tParams.height = 0;
        tParams.floorOffset = 0.0;
        tParams.color = "#ffffff";
        return (tParams);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    create2dGeometry(pParent) {
        // this.setPoints();
        this.mTrackCAGData = [];
        if (this.mRunningTrack !== undefined) {
            this.mRunningTrack.sides = [];
        }
        if (this.mTrackLines !== undefined) {
            this.mTrackLines.sides = [];
        }
        // CAG creation
        this.createInnerBorder(pParent);
        // if (this.mRoomElement.Params.arenaPlayFieldVisible) {
        this.createPlayingField(pParent);
        // }
        // if (this.mRoomElement.Params.arenaSideSegmentsVisible) {
        this.createSideSegments(pParent);
        // }
        this.createTrackParts(pParent);
        // merge CAG
        this.mergeTrackLines();
        // create meshes
        // running track
        if (this.mRunningTrack !== undefined && this.mRunningTrack.sides.length > 0) {
            this.mRoomElement.setCAG_Arena_RunningTracks(this.mRunningTrack);
            this.mRoomElement.setCAGoriginal__Arena_RunningTracks(this.mRunningTrack);
            let tCSGBase = Util.CAG2CSG(this.mRunningTrack, 0);
            let tMeshes_base = this.createMeshOfCSG(pParent, 'room_Arena_RunningTracks', tCSGBase, this.mRoomElement.localMaterial);
            if (tMeshes_base == null) {
                return;
            }
            this.mRoomElement.setCAG(this.mRunningTrack);
            this.mRoomElement.setCAG_notVisible(this.mRunningTrack);
            this.prepare2dMesh(tMeshes_base[0]);
        }
        // track lines
        if (this.mTrackLines !== undefined && this.mTrackLines.sides.length > 0) {
            this.mRoomElement.setCAG_Arena_TrackLines(this.mTrackLines);
            this.mRoomElement.setCAGoriginal__Arena_TrackLines(this.mTrackLines);
            let tCSGBase = Util.CAG2CSG(this.mTrackLines, 0);
            let tMeshes_base = this.createMeshOfCSG(pParent, 'room_Arena_TrackLines', tCSGBase, this.mRoomElement.localMaterial_Arena_TrackLines);
            if (tMeshes_base == null) {
                return;
            }
            this.prepare2dMesh(tMeshes_base[0]);
        }
    }
    create3dGeometry(pParent) {
        if (this.mRoomElement.Params.arenaPlayFieldVisible) {
            this.createPlayingField(pParent);
        }
        if (this.mRoomElement.Params.arenaSideSegmentsVisible) {
            this.createSideSegments(pParent);
        }
        // create meshes
        // running track
        if (this.mRunningTrack !== undefined && this.mRunningTrack.sides.length > 0) {
            let tCSGBase = Util.CAG2CSG(this.mRunningTrack, 0);
            let tMeshes_base = this.createMeshOfCSG(pParent, 'room_Arena_RunningTracks', tCSGBase, this.mRoomElement.localMaterial);
            if (tMeshes_base == null) {
                return;
            }
            this.mRoomElement.setCAG(this.mRunningTrack);
            this.mRoomElement.setCAG_notVisible(this.mRunningTrack);
            this.prepare3dMesh(tMeshes_base[0]);
        }
        // running track
        if (this.mTrackLines !== undefined && this.mTrackLines.sides.length > 0) {
            let tCSGBase = Util.CAG2CSG(this.mTrackLines, 0);
            let tMeshes_base = this.createMeshOfCSG(pParent, 'room_Arena_TrackLines', tCSGBase, this.mRoomElement.localMaterial_Arena_TrackLines);
            if (tMeshes_base == null) {
                return;
            }
            this.prepare3dMesh(tMeshes_base[0]);
        }
    }
    getPropertyClasses() {
        return (Promise.resolve(this.mRoomManager.PropClasses));
    }
    // tslint:disable-next-line:cyclomatic-complexity
    getProperties() {
        let tProperties = new Array();
        let tYesNoChoices = new Array();
        for (let tYesNo of this.mRoomManager._YesNo) {
            tYesNoChoices.push(this.mRoomManager._getYesNoPropValue(tYesNo));
        }
        let tOvalCircleChoices = this.mRoomManager._getOvalCirclePropValue();
        // shape type (oval, cirlce)
        let tshapeTypeProp = new BoolProperty(this.mRoomElement, Arena.PROP_KEY_SHAPETYPE, this.mRoomManager.resources.propertyArenaShape);
        tshapeTypeProp.class = "base";
        tshapeTypeProp.choiceList = true;
        tshapeTypeProp.getChoices = () => Promise.resolve(tOvalCircleChoices);
        tshapeTypeProp.getValue = () => this.mRoomManager._getArenaShapePropValue(this.mRoomElement.Params.arenaCircle);
        tshapeTypeProp.setValue = (pValue) => {
            let tValue = StringProperty.ConvertValueToString(pValue);
            if (tValue != null) {
                this.mRoomElement.setArenaShapeType(tValue);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tProperties.push(tshapeTypeProp);
        // inner lane length
        let tinnerLaneLenghtProp = new LengthProperty(this.mRoomElement, Arena.PROP_KEY_LANELENGTH, this.mRoomManager.resources.propertyLaneLength);
        tinnerLaneLenghtProp.class = "base";
        tinnerLaneLenghtProp.minValue = 10;
        tinnerLaneLenghtProp.maxValue = 400;
        tinnerLaneLenghtProp.numDigits = 4;
        tinnerLaneLenghtProp.numDecDigits = 0;
        if (this.mRoomElement.Params.arenaCircle) {
            const tPerimeter = 400 * this.mRoomElement.Params.arenaLaneScale;
            tinnerLaneLenghtProp.getValue = () => new PropertyValue(tPerimeter);
        }
        else {
            tinnerLaneLenghtProp.getValue = () => new PropertyValue(this.mInnerLaneLength);
        }
        tinnerLaneLenghtProp.setValue = (pValue) => {
            let tValue = LengthProperty.ConvertValueToNumber(pValue);
            if (tValue != null) {
                this.mRoomElement.setArenaLaneLength(tValue);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tProperties.push(tinnerLaneLenghtProp);
        // field length offset
        let tFieldLengthOffsetProp = new LengthProperty(this.mRoomElement, Arena.PROP_KEY_LANELENGTHOFFSET, this.mRoomManager.resources.propertyLaneLengthOffset);
        tFieldLengthOffsetProp.class = "base";
        tFieldLengthOffsetProp.minValue = -500;
        tFieldLengthOffsetProp.maxValue = 500;
        tFieldLengthOffsetProp.getValue = () => this.mRoomElement.getArenaFieldScaleOffset();
        tFieldLengthOffsetProp.setValue = (pValue) => {
            let tValue = LengthProperty.ConvertValueToNumber(pValue);
            if (tValue != null) {
                this.mRoomElement.setArenaFieldScaleOffset(tValue);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        if (this.mRoomElement.Params.arenaCircle) {
            tFieldLengthOffsetProp.visible = false;
        }
        tProperties.push(tFieldLengthOffsetProp);
        // lane count
        let tLaneCountProp = new NumberProperty(this.mRoomElement, Arena.PROP_KEY_LANECOUNT, this.mRoomManager.resources.propertyLaneCount);
        tLaneCountProp.class = "base";
        tLaneCountProp.minValue = 1;
        tLaneCountProp.maxValue = 8;
        tLaneCountProp.getValue = () => new PropertyValue(this.mRoomElement.Params.arenaLaneCount);
        tLaneCountProp.setValue = (pValue) => {
            let tValue = NumberProperty.ConvertValueToNumber(pValue);
            if (tValue != null && this.mRoomElement.setArenaLaneCount(tValue))
                return (Promise.resolve(PropertyChangedResult.Value));
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tProperties.push(tLaneCountProp);
        let tMaterialCategory = this.mRoomManager.getMaterial_Categories(this.mRoomElement.type);
        //material category: track lane
        let tmatCat_TrackLaneProp = new NumberProperty(this.mRoomElement, Arena.PROP_KEY_MATCAT_TRACKLANE, this.mRoomManager.resources.propertyMaterialCategory);
        tmatCat_TrackLaneProp.class = "material_arena_tracklane";
        tmatCat_TrackLaneProp.choiceList = true;
        tmatCat_TrackLaneProp.getChoices = () => Promise.resolve(tMaterialCategory);
        tmatCat_TrackLaneProp.getValue = () => this.mRoomManager.getMaterialCategoryValue(tMaterialCategory, this.mRoomElement.materialSet);
        tmatCat_TrackLaneProp.setValue = (pValue) => {
            if (pValue != null) {
                this.mRoomElement.setMaterialCategory(StringProperty.ConvertValueToString(pValue), undefined, undefined, this.mRoomElement.materialSet);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tProperties.push(tmatCat_TrackLaneProp);
        //material value: track lane
        let tcatName_TrackLane = this.mRoomElement.materialSet.category === "color" ? this.mRoomManager.resources.propertyColor : this.mRoomManager.resources.propertyMaterial;
        let tmat_TrackLaneProp;
        if (this.mRoomElement.materialSet.category === "color") {
            tmat_TrackLaneProp = new Color3Property(this.mRoomElement, Arena.PROP_KEY_MAT_TRACKLANE, tcatName_TrackLane);
        }
        else {
            tmat_TrackLaneProp = new StringProperty(this.mRoomElement, Arena.PROP_KEY_MAT_TRACKLANE, tcatName_TrackLane);
        }
        tmat_TrackLaneProp.class = "material_arena_tracklane";
        tmat_TrackLaneProp.choiceList = true;
        this.mMatOfCatList_Area_TrackLane = this.mRoomManager.getMaterialsOfCategory(this.mRoomElement.materialSet, this.mRoomElement.type);
        tmat_TrackLaneProp.getChoices = () => Promise.resolve(this.mMatOfCatList_Area_TrackLane);
        tmat_TrackLaneProp.getValue = () => this.mRoomManager.getMaterialValue(this.mRoomElement.materialSet, this.mMatOfCatList_Area_TrackLane);
        tmat_TrackLaneProp.setValue = (pValue) => {
            let tValue = StringProperty.ConvertValueToString(pValue);
            if (tValue != null) {
                this.mRoomElement.setMaterialValue__(tValue, this.mRoomElement.materialSet, true);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tProperties.push(tmat_TrackLaneProp);
        // playing field visibility
        let tplayFieldVisProp = new BoolProperty(this.mRoomElement, Arena.PROP_KEY_PLAYFIELDVIS, this.mRoomManager.resources.propertyVisible);
        tplayFieldVisProp.class = "material_arena_playfield";
        tplayFieldVisProp.choiceList = true;
        tplayFieldVisProp.getChoices = () => Promise.resolve(tYesNoChoices);
        tplayFieldVisProp.getValue = () => this.mRoomManager._getYesNoPropValue(this.mRoomElement.Params.arenaPlayFieldVisible);
        tplayFieldVisProp.setValue = (pValue) => {
            if (pValue != null) {
                let tval = BoolProperty.ConvertValueToBool(pValue);
                this.mRoomElement.setArenaPlayFieldVisible(tval);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tplayFieldVisProp.visible = true;
        tProperties.push(tplayFieldVisProp);
        //material category: playing field
        let tmatCat_PlayFieldProp = new NumberProperty(this.mRoomElement, Arena.PROP_KEY_MATCAT_PLAYFIELD, this.mRoomManager.resources.propertyMaterialCategory);
        tmatCat_PlayFieldProp.class = "material_arena_playfield";
        tmatCat_PlayFieldProp.choiceList = true;
        tmatCat_PlayFieldProp.getChoices = () => Promise.resolve(tMaterialCategory);
        tmatCat_PlayFieldProp.getValue = () => this.mRoomManager.getMaterialCategoryValue(tMaterialCategory, this.mRoomElement.materialSet_Arena_PlayField);
        tmatCat_PlayFieldProp.setValue = (pValue) => {
            if (pValue != null) {
                this.mRoomElement.setMaterialCategory(StringProperty.ConvertValueToString(pValue), undefined, undefined, this.mRoomElement.materialSet_Arena_PlayField);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tProperties.push(tmatCat_PlayFieldProp);
        //material value: play field
        let tcatName_PlayField = this.mRoomElement.materialSet_Arena_PlayField.category === "color" ?
            this.mRoomManager.resources.propertyColor : this.mRoomManager.resources.propertyMaterial;
        let tmat_PlayFieldProp;
        if (this.mRoomElement.materialSet_Arena_PlayField.category === "color") {
            tmat_PlayFieldProp = new Color3Property(this.mRoomElement, Arena.PROP_KEY_MAT_PLAYFIELD, tcatName_PlayField);
        }
        else {
            tmat_PlayFieldProp = new StringProperty(this.mRoomElement, Arena.PROP_KEY_MAT_PLAYFIELD, tcatName_PlayField);
        }
        tmat_PlayFieldProp.class = "material_arena_playfield";
        tmat_PlayFieldProp.choiceList = true;
        this.mMatOfCatList_Area_PlayField = this.mRoomManager.getMaterialsOfCategory(this.mRoomElement.materialSet_Arena_PlayField, this.mRoomElement.type);
        tmat_PlayFieldProp.getChoices = () => Promise.resolve(this.mMatOfCatList_Area_PlayField);
        tmat_PlayFieldProp.getValue = () => this.mRoomManager.getMaterialValue(this.mRoomElement.materialSet_Arena_PlayField, this.mMatOfCatList_Area_PlayField);
        tmat_PlayFieldProp.setValue = (pValue) => {
            let tValue = StringProperty.ConvertValueToString(pValue);
            if (tValue != null) {
                this.mRoomElement.setMaterialValue__(tValue, this.mRoomElement.materialSet_Arena_PlayField, true);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tProperties.push(tmat_PlayFieldProp);
        // side segments visibility
        let tsideSegmentsVisProp = new BoolProperty(this.mRoomElement, Arena.PROP_KEY_SIDESEGMENTSVIS, this.mRoomManager.resources.propertyVisible);
        tsideSegmentsVisProp.class = "material_arena_sidesegments";
        tsideSegmentsVisProp.choiceList = true;
        tsideSegmentsVisProp.getChoices = () => Promise.resolve(tYesNoChoices);
        tsideSegmentsVisProp.getValue = () => this.mRoomManager._getYesNoPropValue(this.mRoomElement.Params.arenaSideSegmentsVisible);
        tsideSegmentsVisProp.setValue = (pValue) => {
            if (pValue != null) {
                let tval = BoolProperty.ConvertValueToBool(pValue);
                this.mRoomElement.setArenaSideSegmentsVisible(tval);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        if (this.mRoomElement.Params.arenaCircle) {
            tsideSegmentsVisProp.visible = false;
        }
        tProperties.push(tsideSegmentsVisProp);
        //material category: side segments
        let tmatCat_SideSegmentsProp = new NumberProperty(this.mRoomElement, Arena.PROP_KEY_MATCAT_SIDESEGMENTS, this.mRoomManager.resources.propertyMaterialCategory);
        tmatCat_SideSegmentsProp.class = "material_arena_sidesegments";
        tmatCat_SideSegmentsProp.choiceList = true;
        tmatCat_SideSegmentsProp.getChoices = () => Promise.resolve(tMaterialCategory);
        tmatCat_SideSegmentsProp.getValue = () => this.mRoomManager.getMaterialCategoryValue(tMaterialCategory, this.mRoomElement.materialSet_Arena_SideSegments);
        tmatCat_SideSegmentsProp.setValue = (pValue) => {
            if (pValue != null) {
                this.mRoomElement.setMaterialCategory(StringProperty.ConvertValueToString(pValue), undefined, undefined, this.mRoomElement.materialSet_Arena_SideSegments);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        if (this.mRoomElement.Params.arenaCircle) {
            tmatCat_SideSegmentsProp.visible = false;
        }
        tProperties.push(tmatCat_SideSegmentsProp);
        //material value: side segments
        let tcatName_SideSegments = this.mRoomElement.materialSet_Arena_SideSegments.category === "color" ?
            this.mRoomManager.resources.propertyColor : this.mRoomManager.resources.propertyMaterial;
        let tmat_SideSegmentsProp;
        if (this.mRoomElement.materialSet_Arena_SideSegments.category === "color") {
            tmat_SideSegmentsProp = new Color3Property(this.mRoomElement, Arena.PROP_KEY_MAT_SIDESEGMENTS, tcatName_SideSegments);
        }
        else {
            tmat_SideSegmentsProp = new StringProperty(this.mRoomElement, Arena.PROP_KEY_MAT_SIDESEGMENTS, tcatName_SideSegments);
        }
        tmat_SideSegmentsProp.class = "material_arena_sidesegments";
        tmat_SideSegmentsProp.choiceList = true;
        this.mMatOfCatList_Area_SideSegments = this.mRoomManager.getMaterialsOfCategory(this.mRoomElement.materialSet_Arena_SideSegments, this.mRoomElement.type);
        tmat_SideSegmentsProp.getChoices = () => Promise.resolve(this.mMatOfCatList_Area_SideSegments);
        tmat_SideSegmentsProp.getValue = () => this.mRoomManager.getMaterialValue(this.mRoomElement.materialSet_Arena_SideSegments, this.mMatOfCatList_Area_SideSegments);
        tmat_SideSegmentsProp.setValue = (pValue) => {
            let tValue = StringProperty.ConvertValueToString(pValue);
            if (tValue != null) {
                this.mRoomElement.setMaterialValue__(tValue, this.mRoomElement.materialSet_Arena_SideSegments, true);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        if (this.mRoomElement.Params.arenaCircle) {
            tmat_SideSegmentsProp.visible = false;
        }
        tProperties.push(tmat_SideSegmentsProp);
        //material category: track line
        let tmatCat_TrackLineProp = new NumberProperty(this.mRoomElement, Arena.PROP_KEY_MATCAT_TRACKLINE, this.mRoomManager.resources.propertyMaterialCategory);
        tmatCat_TrackLineProp.class = "material_arena_trackline";
        tmatCat_TrackLineProp.choiceList = true;
        tmatCat_TrackLineProp.getChoices = () => Promise.resolve(tMaterialCategory);
        tmatCat_TrackLineProp.getValue = () => this.mRoomManager.getMaterialCategoryValue(tMaterialCategory, this.mRoomElement.materialSet_Arena_TrackLines);
        tmatCat_TrackLineProp.setValue = (pValue) => {
            if (pValue != null) {
                this.mRoomElement.setMaterialCategory(StringProperty.ConvertValueToString(pValue), undefined, undefined, this.mRoomElement.materialSet_Arena_TrackLines);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tProperties.push(tmatCat_TrackLineProp);
        //material value: track line
        let tcatName_TrackLine = this.mRoomElement.materialSet_Arena_TrackLines.category === "color" ?
            this.mRoomManager.resources.propertyColor : this.mRoomManager.resources.propertyMaterial;
        let tmat_TrackLineProp;
        if (this.mRoomElement.materialSet_Arena_TrackLines.category === "color") {
            tmat_TrackLineProp = new Color3Property(this.mRoomElement, Arena.PROP_KEY_MAT_TRACKLINE, tcatName_TrackLine);
        }
        else {
            tmat_TrackLineProp = new StringProperty(this.mRoomElement, Arena.PROP_KEY_MAT_TRACKLINE, tcatName_TrackLine);
        }
        tmat_TrackLineProp.class = "material_arena_trackline";
        tmat_TrackLineProp.choiceList = true;
        this.mMatOfCatList_Area_TrackLine = this.mRoomManager.getMaterialsOfCategory(this.mRoomElement.materialSet_Arena_TrackLines, this.mRoomElement.type);
        tmat_TrackLineProp.getChoices = () => Promise.resolve(this.mMatOfCatList_Area_TrackLine);
        tmat_TrackLineProp.getValue = () => this.mRoomManager.getMaterialValue(this.mRoomElement.materialSet_Arena_TrackLines, this.mMatOfCatList_Area_TrackLine);
        tmat_TrackLineProp.setValue = (pValue) => {
            let tValue = StringProperty.ConvertValueToString(pValue);
            if (tValue != null) {
                this.mRoomElement.setMaterialValue__(tValue, this.mRoomElement.materialSet_Arena_TrackLines, true);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        tProperties.push(tmat_TrackLineProp);
        return (tProperties);
    }
    serializeIOData() {
        return (this.mElementParams);
    }
    loadIOData(pData) {
        //
    }
    getEOXDescription(pDocument, pParentNode) {
        let tAttribsList = new Array();
        tAttribsList = [];
        tAttribsList.push({ qualifiedName: "structure_type", value: "Pillar_Box" });
        let tRoomElementNode = Util._xmlAddChildNode(pDocument, pParentNode, "object", "", tAttribsList);
        // define category
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "category", "Other", null);
        // position
        tAttribsList = [];
        tAttribsList.push({ qualifiedName: "x", value: this.mRoomElement.node.position.x.toString() });
        tAttribsList.push({ qualifiedName: "y", value: (this.mRoomElement.node.position.y).toString() });
        tAttribsList.push({ qualifiedName: "z", value: (-this.mRoomElement.node.position.z).toString() });
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "position", "", tAttribsList);
        // rotation
        let t3dRotation = this.mRoomElement.node.rotationQuaternion;
        tAttribsList = [];
        if (t3dRotation != null) {
            tAttribsList.push({ qualifiedName: "x", value: (-t3dRotation.x).toString() });
            tAttribsList.push({ qualifiedName: "y", value: (-t3dRotation.z).toString() });
            tAttribsList.push({ qualifiedName: "z", value: (-t3dRotation.y).toString() });
            tAttribsList.push({ qualifiedName: "w", value: (-t3dRotation.w).toString() });
            Util._xmlAddChildNode(pDocument, tRoomElementNode, "rotation", "", tAttribsList);
        }
        else {
            tAttribsList.push({ qualifiedName: "x", value: "0" });
            tAttribsList.push({ qualifiedName: "y", value: "0" });
            tAttribsList.push({ qualifiedName: "z", value: "0" });
            tAttribsList.push({ qualifiedName: "w", value: "1" });
            Util._xmlAddChildNode(pDocument, tRoomElementNode, "rotation", "", tAttribsList);
        }
        // width
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "width", this.mRoomElement.depth.toString(), null);
        // depth
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "depth", this.mRoomElement.width.toString(), null);
        // height
        Util._xmlAddChildNode(pDocument, tRoomElementNode, "height", this.mRoomElement.height.toString(), null);
        // color
        tAttribsList = [];
        if (this.mRoomElement.color.trim() !== '') {
            let tcolor = Util.hexToRGB(this.mRoomElement.color);
            tAttribsList.push({ qualifiedName: "r", value: tcolor.r.toString() });
            tAttribsList.push({ qualifiedName: "g", value: tcolor.g.toString() });
            tAttribsList.push({ qualifiedName: "b", value: tcolor.b.toString() });
            Util._xmlAddChildNode(pDocument, tRoomElementNode, "color", "", tAttribsList);
        }
    }
    setPoints() {
        this.mPoints = [];
        let tWH = this.mRoomElement.width * 0.5;
        let tDH = this.mRoomElement.depth * 0.5;
        this.mPoints.push(new Vector3(-tWH, 0, tDH));
        this.mPoints.push(new Vector3(-tWH, 0, -tDH));
        this.mPoints.push(new Vector3(tWH, 0, -tDH));
        this.mPoints.push(new Vector3(tWH, 0, tDH));
        this.mPoints.push(new Vector3(-tWH, 0, tDH));
    }
    createCircleTrack(pScale) {
        const tperimeter = 400 * pScale;
        const tradius = tperimeter / Math.PI / 2;
        const tCAG = CAG.circle({ radius: tradius, resolution: Arena.TESSELLATION * 2 });
        const tpoints = tCAG.toPoints();
        let tRes = [];
        for (let tP of tpoints) {
            tRes.push(new Vector3(tP.x, 0, tP.y));
        }
        this.mInField = tRes.slice();
        return (tRes);
    }
    createInnerBorder(pParent) {
        let tclosedPoly = [];
        if (!this.mRoomElement.Params.arenaCircle) {
            tclosedPoly = this.createTrack(this.mRoomElement.Params.arenaLaneScale);
        }
        else {
            tclosedPoly = this.createCircleTrack(this.mRoomElement.Params.arenaLaneScale);
        }
        const tlen = Util.getPerimeterOfClosedPolygon(tclosedPoly);
        this.mInnerLaneLength = tlen;
        if (tclosedPoly.length < 4) {
            return;
        }
        let toffsetData = this.createOffsetPolygon(tclosedPoly, 0.1);
        this.mPrevPolygon = toffsetData.outerPolygon;
        let tCAG = this.createCAG(toffsetData.CAGPoly);
        if (tCAG == null) {
            return;
        }
        toffsetData.CAG = tCAG;
        toffsetData.type = RoomElement.TrackPart.TrackLine;
        // if (this.mTrackLines === undefined) {
        //     this.mTrackLines = new CAG();
        // }
        // this.mTrackLines.sides = this.mTrackLines.sides.concat(tCAG.sides);
        this.mTrackCAGData.push(toffsetData);
        // let tCSGBase = Util.CAG2CSG(tCAG, 0);
        // let tMeshes_base = this.createMeshOfCSG(pParent, 'room_Arena_InnerBorder', tCSGBase, this.mRoomElement.localMaterial_Arena_TrackLines);
        // if (tMeshes_base == null) {
        //     return;
        // }
        // this.mRoomElement.setCAG(tCAG);
        // this.mRoomElement.setCAG_notVisible(tCAG);
        // this.prepare3dMesh(tMeshes_base[0]);
    }
    createTrackParts(pParent) {
        for (let i = 0; i < this.mRoomElement.Params.arenaLaneCount; i++) {
            this.createRunningTrack(pParent);
            this.createTrackLine(pParent);
        }
    }
    createRunningTrack(pParent) {
        if (this.mPrevPolygon.length < 4) {
            return;
        }
        let toffsetData = this.createOffsetPolygon(this.mPrevPolygon, Arena.RUNNINGTRACK_WIDTH);
        this.mPrevPolygon = toffsetData.outerPolygon;
        let tCAG = this.createCAG(toffsetData.CAGPoly);
        if (tCAG == null) {
            return;
        }
        toffsetData.CAG = tCAG;
        toffsetData.type = RoomElement.TrackPart.RunningTrack;
        // if (this.mRunningTrack === undefined) {
        //     this.mRunningTrack = new CAG();
        // }
        // this.mRunningTrack.sides = this.mRunningTrack.sides.concat(tCAG.sides);
        this.mTrackCAGData.push(toffsetData);
        // let tCSGBase = Util.CAG2CSG(tCAG, 0);
        // let tMeshes_base = this.createMeshOfCSG(pParent, 'room_Arena_RunningTrack', tCSGBase, this.mRoomElement.localMaterial);
        // if (tMeshes_base == null) {
        //     return;
        // }
        // this.mRoomElement.setCAG(tCAG);
        // this.mRoomElement.setCAG_notVisible(tCAG);
        // this.prepare3dMesh(tMeshes_base[0]);
    }
    createTrackLine(pParent) {
        if (this.mPrevPolygon.length < 4) {
            return;
        }
        let toffsetData = this.createOffsetPolygon(this.mPrevPolygon, Arena.TRACKLINE_WIDTH);
        this.mPrevPolygon = toffsetData.outerPolygon;
        let tCAG = this.createCAG(toffsetData.CAGPoly);
        if (tCAG == null) {
            return;
        }
        toffsetData.CAG = tCAG;
        toffsetData.type = RoomElement.TrackPart.TrackLine;
        // if (this.mTrackLines === undefined) {
        //     this.mTrackLines = new CAG();
        // }
        // this.mTrackLines.sides = this.mTrackLines.sides.concat(tCAG.sides);
        this.mTrackCAGData.push(toffsetData);
        // const tlineColor = this.mRoomManager.createColorMaterial('#ffffff', true);
        // let tCSGBase = Util.CAG2CSG(tCAG, 0);
        // let tMeshes_base = this.createMeshOfCSG(pParent, 'room_Arena_TrackLine', tCSGBase, this.mRoomElement.localMaterial_Arena_TrackLines);
        // if (tMeshes_base == null) {
        //     return;
        // }
        // this.mRoomElement.setCAG(tCAG);
        // this.mRoomElement.setCAG_notVisible(tCAG);
        // this.prepare3dMesh(tMeshes_base[0]);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    createTrack(pScale = 1) {
        let tW = this.mRoomElement.Params.arenaSegRadius * pScale;
        let tDist = this.mRoomElement.Params.arenaFieldLength * 0.5 * pScale * this.mRoomElement.Params.arenaFieldScale;
        let tmyPoints = [];
        this.mInField = [];
        const tTessellationFak = 180 / Arena.TESSELLATION;
        const toffDist = 0.477698 * pScale;
        // arc left
        let tarcLeft = [];
        for (let i = 0; i < Arena.TESSELLATION + 1; i++) {
            let tDeg = degToRad(i * tTessellationFak + 90);
            let tCosA = Math.cos(tDeg);
            let tSinA = Math.sin(tDeg);
            tarcLeft.push(new Vector3(tCosA * tW - tDist - toffDist, 0.0, tSinA * tW));
            tmyPoints.push(new Vector3(tCosA * tW - tDist - toffDist, 0.0, tSinA * tW));
        }
        //arc right
        let tarcRight = [];
        for (let i1 = 0; i1 < Arena.TESSELLATION + 1; i1++) {
            let tDeg = degToRad(i1 * tTessellationFak - 90);
            let tCosA = Math.cos(tDeg);
            let tSinA = Math.sin(tDeg);
            tarcRight.push(new Vector3(tCosA * tW + tDist + toffDist, 0.0, tSinA * tW));
            tmyPoints.push(new Vector3(tCosA * tW + tDist + toffDist, 0.0, tSinA * tW));
        }
        this.mArcLeft = tarcLeft.slice();
        this.mArcRight = tarcRight.slice();
        const tDistCnt = 5;
        // shift left arc
        for (let i = 0; i < tDistCnt; i++) {
            const tP = this.mArcLeft.shift();
            if (tP != null) {
                this.mInField.push(tP);
            }
        }
        this.mInField.push(this.mArcLeft[0]);
        // pop reverse
        let tleftRev = [];
        for (let i = 0; i < tDistCnt; i++) {
            const tP = this.mArcLeft.pop();
            if (tP != null) {
                tleftRev.push(tP);
            }
        }
        tleftRev.reverse();
        this.mInField.push(this.mArcLeft[this.mArcLeft.length - 1]);
        this.mInField = this.mInField.concat(tleftRev);
        // shift right arc
        for (let i = 0; i < tDistCnt; i++) {
            const tP = this.mArcRight.shift();
            if (tP != null) {
                this.mInField.push(tP);
            }
        }
        this.mInField.push(this.mArcRight[0]);
        // pop reverse
        let trightRev = [];
        for (let i = 0; i < tDistCnt; i++) {
            const tP = this.mArcRight.pop();
            if (tP != null) {
                trightRev.push(tP);
            }
        }
        trightRev.reverse();
        this.mInField.push(this.mArcRight[this.mArcRight.length - 1]);
        this.mInField = this.mInField.concat(trightRev);
        tmyPoints.push(tmyPoints[0]);
        return (tmyPoints);
    }
    createPlayingField(pParent) {
        if (this.mInField.length < 3) {
            return;
        }
        const tCAG = Util.polygon2CAG(this.mInField);
        if (tCAG == null) {
            return;
        }
        this.mRoomElement.setCAG_Arena_PlayField(tCAG);
        this.mRoomElement.setCAGoriginal__Arena_InField(tCAG);
        let tCSGBase = Util.CAG2CSG(tCAG, 0);
        if (this.mRoomElement.Params.arenaPlayFieldVisible) {
            this.createMeshOfCSG(pParent, 'room_Arena_PlayingField', tCSGBase, this.mRoomElement.localMaterial_Arena_PlayField);
        }
    }
    createSideSegments(pParent) {
        if ((this.mArcLeft == null || this.mArcRight == null) ||
            (this.mArcLeft.length === 0 || this.mArcRight.length === 0)) {
            return;
        }
        //arc left
        let tarcLeft = this.mArcLeft.slice();
        // tarcLeft.push(tarcLeft[0]);
        let tarcRight = this.mArcRight.slice();
        // tarcRight.push(tarcRight[0]);
        let tarrCAGsides = [];
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < tarcLeft.length - 1; i++) {
            let tvertex0 = new CAG.Vertex(new CSG.Vector2D(tarcLeft[i].x, tarcLeft[i].z));
            let tvertex1 = new CAG.Vertex(new CSG.Vector2D(tarcLeft[i + 1].x, tarcLeft[i + 1].z));
            let tCAGside = new CAG.Side(tvertex0, tvertex1);
            tarrCAGsides.push(tCAGside);
        }
        let tvertex00 = new CAG.Vertex(new CSG.Vector2D(tarcLeft[tarcLeft.length - 1].x, tarcLeft[tarcLeft.length - 1].z));
        let tvertex01 = new CAG.Vertex(new CSG.Vector2D(tarcLeft[0].x, tarcLeft[0].z));
        let tCAGside0 = new CAG.Side(tvertex00, tvertex01);
        tarrCAGsides.push(tCAGside0);
        for (let i = 0; i < tarcRight.length - 1; i++) {
            let tvertex0 = new CAG.Vertex(new CSG.Vector2D(tarcRight[i].x, tarcRight[i].z));
            let tvertex1 = new CAG.Vertex(new CSG.Vector2D(tarcRight[i + 1].x, tarcRight[i + 1].z));
            let tCAGside = new CAG.Side(tvertex0, tvertex1);
            tarrCAGsides.push(tCAGside);
        }
        let tvertex10 = new CAG.Vertex(new CSG.Vector2D(tarcRight[tarcRight.length - 1].x, tarcRight[tarcRight.length - 1].z));
        let tvertex11 = new CAG.Vertex(new CSG.Vector2D(tarcRight[0].x, tarcRight[0].z));
        let tCAGside1 = new CAG.Side(tvertex10, tvertex11);
        tarrCAGsides.push(tCAGside1);
        let tCAG = CAG.fromSides(tarrCAGsides);
        tCAG.isCanonicalized = true;
        this.mRoomElement.setCAG_Arena_SideSegments(tCAG);
        this.mRoomElement.setCAGoriginal__Arena_SideSegements(tCAG);
        let tCSG = Util.CAG2CSG(tCAG, 0);
        if (this.mRoomElement.Params.arenaSideSegmentsVisible) {
            this.createMeshOfCSG(pParent, 'room_Arena_SideSegments', tCSG, this.mRoomElement.localMaterial_Arena_SideSegments);
        }
    }
    mergeTrackLines() {
        for (let tTP of this.mTrackCAGData) {
            switch (tTP.type) {
                case RoomElement.TrackPart.RunningTrack:
                    if (this.mRunningTrack === undefined) {
                        this.mRunningTrack = new CAG();
                    }
                    this.mRunningTrack.sides = this.mRunningTrack.sides.concat(tTP.CAG.sides);
                    break;
                case RoomElement.TrackPart.TrackLine:
                    if (this.mTrackLines === undefined) {
                        this.mTrackLines = new CAG();
                    }
                    this.mTrackLines.sides = this.mTrackLines.sides.concat(tTP.CAG.sides);
                    break;
                default:
                    break;
            }
        }
    }
    createCAG(poffPoints) {
        if (poffPoints.length === 0) {
            return (null);
        }
        let tarrCAGsides = [];
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < poffPoints.length; i++) {
            // tslint:disable-next-line:prefer-for-of
            for (let j = 0; j < poffPoints[i].length - 1; j++) {
                let tvertex0 = new CAG.Vertex(new CSG.Vector2D(poffPoints[i][j].X, poffPoints[i][j].Y));
                let tvertex1 = new CAG.Vertex(new CSG.Vector2D(poffPoints[i][j + 1].X, poffPoints[i][j + 1].Y));
                let tCAGside = new CAG.Side(tvertex0, tvertex1);
                tarrCAGsides.push(tCAGside);
            }
            const tlastIdx = poffPoints[i].length - 1;
            let tv0 = new CAG.Vertex(new CSG.Vector2D(poffPoints[i][tlastIdx].X, poffPoints[i][tlastIdx].Y));
            let tv1 = new CAG.Vertex(new CSG.Vector2D(poffPoints[i][0].X, poffPoints[i][0].Y));
            let tCAGsideClosed = new CAG.Side(tv0, tv1);
            tarrCAGsides.push(tCAGsideClosed);
        }
        let tCAG = CAG.fromSides(tarrCAGsides);
        tCAG.isCanonicalized = true;
        return (tCAG);
    }
    createOffsetPolygon(polygon, spacing) {
        const tRes = {};
        const geoInput = this.Vector3ToClipper2(polygon);
        ClipperLib.JS.ScaleUpPath(geoInput, ElementGeometry.CLIPPER_SCALING_VALUE);
        let clipperOffset = new ClipperLib.ClipperOffset(ElementGeometry.CLIPPER_MITER_LIMIT, 100);
        let tPath = new ClipperLib.Path();
        for (let tP of geoInput) {
            tPath.push(tP);
        }
        clipperOffset.AddPath(tPath, ClipperLib.JoinType.jtMiter, ClipperLib.EndType.etClosedPolygon);
        let tPaths = new ClipperLib.Paths();
        clipperOffset.Execute(tPaths, spacing * ElementGeometry.CLIPPER_SCALING_VALUE);
        let solution = new ClipperLib.Paths();
        let c = new ClipperLib.Clipper();
        if (spacing > 0) {
            c.AddPaths(tPaths, ClipperLib.PolyType.ptSubject, true);
            c.AddPath(geoInput, ClipperLib.PolyType.ptClip, true);
        }
        else {
            c.AddPath(geoInput, ClipperLib.PolyType.ptSubject, true);
            c.AddPaths(tPaths, ClipperLib.PolyType.ptClip, true);
        }
        c.Execute(ClipperLib.ClipType.ctDifference, solution);
        ClipperLib.JS.ScaleDownPaths(solution, ElementGeometry.CLIPPER_SCALING_VALUE);
        ClipperLib.JS.ScaleDownPaths(tPaths, ElementGeometry.CLIPPER_SCALING_VALUE);
        tRes.CAGPoly = solution;
        tRes.outerPolygon = this.Clipper2ToVector3(tPaths[0]);
        return (tRes);
    }
    Vector3ToClipper2(tPoints) {
        return tPoints.map((point) => new ClipperLib.IntPoint(point.x, point.z));
    }
    Clipper2ToVector3(tPoints) {
        return tPoints.map((point) => new Vector3(point.X, 0, point.Y));
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
Arena.RUNNINGTRACK_WIDTH = 1.17;
Arena.TRACKLINE_WIDTH = 0.05;
Arena.TESSELLATION = 45;
Arena.PROP_KEY_SHAPETYPE = "room:RoomElement:Arena:shapeType";
Arena.PROP_KEY_LANELENGTH = "room:RoomElement:Arena:laneLength";
Arena.PROP_KEY_LANELENGTHOFFSET = "room:RoomElement:Arena:laneLengthOffset";
Arena.PROP_KEY_LANECOUNT = "room:RoomElement:Arena:laneCount";
Arena.PROP_KEY_MAT_TRACKLANE = "room:RoomElement:Arena:mat:tracklane";
Arena.PROP_KEY_MATCAT_TRACKLANE = "room:RoomElement:Arena:matcat:tracklane";
Arena.PROP_KEY_PLAYFIELDVIS = "room:RoomElement:Arena:playfieldVisible";
Arena.PROP_KEY_MAT_PLAYFIELD = "room:RoomElement:Arena:mat:playfield";
Arena.PROP_KEY_MATCAT_PLAYFIELD = "room:RoomElement:Arena:matcat:playfield";
Arena.PROP_KEY_SIDESEGMENTSVIS = "room:RoomElement:Arena:sidesegmentsVisible";
Arena.PROP_KEY_MAT_SIDESEGMENTS = "room:RoomElement:Arena:mat:sidesegments";
Arena.PROP_KEY_MATCAT_SIDESEGMENTS = "room:RoomElement:Arena:matcat:sidesegments";
Arena.PROP_KEY_MAT_TRACKLINE = "room:RoomElement:Arena:mat:trackline";
Arena.PROP_KEY_MATCAT_TRACKLINE = "room:RoomElement:Arena:matcat:trackline";
